<nav
    class="navbar navbar-expand-lg navbar-light bg-light"
    [class.active]="classApplied"
    [ngClass]="{'sticky': isSticky}"
>
    <div class="container">
        <a class="navbar-brand" routerLink="/"><span>hit</span>-FLUENCER</a>
        <button class="navbar-toggler" type="button" (click)="toggleClass()">
            <span class="burger-menu">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span>
            </span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item"><span class="nav-link" (click)="onClick('home')">Home</span></li>
                <li class="nav-item"><span class="nav-link" (click)="onClick('charts')">Le nostre classifiche</span></li>
                <li class="nav-item"><span class="nav-link" (click)="onClick('how-we-work')">Come lavoriamo</span></li>
                <li class="nav-item"><span class="nav-link" (click)="onClick('contact')">Contatti</span></li>
            </ul>
            <ul class="navbar-nav ml-auto for-responsive">
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('home')">Home</span></li>
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('charts')">Le nostre classifiche</span></li>
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('how-we-work')">Come lavoriamo</span></li>
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('contact')">Contatti</span></li>
            </ul>
        </div>
    </div>
</nav>
